module.exports = __webpack_public_path__ + "static/media/4_2.ff4f992b.png";